import { render, staticRenderFns } from "./CompensationProcedureEdit.vue?vue&type=template&id=638af541&scoped=true"
import script from "./CompensationProcedureEdit.vue?vue&type=script&lang=js"
export * from "./CompensationProcedureEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638af541",
  null
  
)

export default component.exports